import Card from "../UI/Card";
// @ts-expect-error pure js
import { dateConvert } from "../../api/Functions";

interface TenantChange {
  change_date: string;
  old_tenant_name?: string;
  new_tenant_name?: string;
  has_reading_at_change: boolean;
}

export interface TenantChangeInfo {
  property_id: number;
  property_name: string;
  changes?: TenantChange[];
}

interface TenantChangesAlertProps {
  tenantChanges: TenantChangeInfo[];
}

export default function TenantChangesAlert({
  tenantChanges,
}: TenantChangesAlertProps) {
  if (
    !tenantChanges ||
    !Array.isArray(tenantChanges) ||
    tenantChanges.length === 0
  ) {
    return null;
  }

  const hasMissingChangeReadings = tenantChanges.some(
    (tc) => tc.changes?.some((change) => !change.has_reading_at_change),
  );

  return (
    <Card
      type={hasMissingChangeReadings ? "warning" : "info"}
      className="marginB10"
      padding="md"
    >
      <div className="flex align-items-center gap5 marginB10">
        <p className="primaryText">Changements de locataire détectés</p>
      </div>

      <p className="secondaryText marginB10">
        {hasMissingChangeReadings
          ? "Des relevés de compteur sont nécessaires aux dates de changement de locataire pour une répartition précise."
          : "La facturation sera répartie entre les locataires selon leur période d'occupation."}
      </p>

      <div className="flex flex-column gap10">
        {tenantChanges.map((tc) => (
          <div key={tc.property_id} className="paddingL10">
            <p className="primaryText" style={{ fontSize: "0.95em" }}>
              {tc.property_name}
            </p>

            {Array.isArray(tc.changes) &&
              tc.changes.map((change, idx) => (
                <div
                  key={idx}
                  className="flex flex-column gap2 paddingL10 marginT5"
                >
                  <p className="secondaryText">
                    {dateConvert(change?.change_date)} :{" "}
                    {change?.old_tenant_name
                      ? `${change.old_tenant_name} → ${
                          change.new_tenant_name || ""
                        }`
                      : `Entrée de ${change?.new_tenant_name || ""}`}
                  </p>

                  {!change.has_reading_at_change && (
                    <p
                      className="secondaryText"
                      style={{
                        color: "var(--color-warning)",
                        fontSize: "0.85em",
                      }}
                    >
                      Relevé manquant à cette date
                    </p>
                  )}
                </div>
              ))}
          </div>
        ))}
      </div>
    </Card>
  );
}
